import { render } from "./SeoMetaInfo.vue?vue&type=template&id=975fc20c"
import script from "./SeoMetaInfo.vue?vue&type=script&lang=js"
export * from "./SeoMetaInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../apps/evankao/game-yiyouwang/yywfront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__